import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import nodata from "../assest/nodata.png";
import { useNavigate } from "react-router-dom";

const TeamLeadAllEmpData = () => {
  const [empData, setEmpData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllEmpData = async () => {
      try {
        const encodedEmployeeId = sessionStorage.getItem(
          "H7Z4L9VD2XK5JW8QRYT6"
        );
        if (!encodedEmployeeId) {
          toast.error("Employee ID not found. Please log in again.");
          setLoading(false);
          return;
        }

        const teamLeadEmpId = atob(encodedEmployeeId); // Decode Base64 ID

        const response = await fetch(SummaryApi.getTodayTlAllEmpData.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sandeep_university_916",
          },
          body: JSON.stringify({ team_lead_emp_id: teamLeadEmpId }),
        });

        const result = await response.json();

        if (
          result.status &&
          Array.isArray(result.data) &&
          result.data.length > 0
        ) {
          // Reverse the data here before setting it
          setEmpData(result.data.reverse());
        } else {
          setEmpData([]); // No data, but still show table
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllEmpData();
  }, []);

  const handleEditClick = async (student) => {
    // Fetch student details
    const responseDetails = await fetch(
      SummaryApi.getStudentDataByStudentId.url,
      {
        method: SummaryApi.getStudentDataByStudentId.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer sandeep_university_916",
        },
        body: JSON.stringify({ student_id: student.student_id }),
      }
    );
    const studentData = (await responseDetails.json()).data || null;

    // Fetch follow-up details
    let followUps = [];
    if (student.tl_student_followup_id) {
      const responseFollow = await fetch(
        SummaryApi.getStudentFollowDetails.url,
        {
          method: SummaryApi.getStudentFollowDetails.method,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sandeep_university_916",
          },
          body: JSON.stringify({
            tl_student_followup_id: student.tl_student_followup_id,
          }),
        }
      );
      const followData = await responseFollow.json();
      followUps = followData.data || [];
    }

    // Navigate to my-history page with state
    navigate("/my-history", {
      state: {
        student,
        studentDetails: studentData,
        studentFollowUps: followUps,
      },
    });
  };

  if (loading)
    return (
      <div className="text-center text-lg font-semibold py-10 text-blue-600">
        Loading employee data...
      </div>
    );

  if (error)
    return (
      <div className="text-center text-red-500 font-semibold py-10">
        {error}
      </div>
    );

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">
        Team Lead All Employee Follow-ups
      </h2>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300 shadow-lg rounded-lg">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="px-4 py-2 text-left">S.No</th>
              <th className="px-4 py-2 text-left">Student Name</th>
              <th className="px-4 py-2 text-left">Mobile</th>
            
              <th className="px-4 py-2 text-left">District</th>
              <th className="px-4 py-2 text-left">City</th>
              <th className="px-4 py-2 text-left">College</th>
              <th className="px-4 py-2 text-left">Interested</th>
              <th className="px-4 py-2 text-left">Lead By</th>
              <th className="px-4 py-2 text-left">Follow-up Date</th>
              <th className="px-4 py-2 text-left">Enrolled Date</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {empData.length === 0 ? (
              <tr>
                <td
                  colSpan="11"
                  className="text-center py-6 text-gray-500 font-medium"
                >
                  <div className="flex items-center justify-center mb-2">
                    <img
                      src={nodata}
                      alt="No data"
                      className="max-w-full h-auto"
                    />
                  </div>
                  No records for today
                </td>
              </tr>
            ) : (
              empData.map((item, index) => (
                <tr
                  key={item.tl_student_followup_id}
                  className={`${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } border-b hover:bg-blue-50 transition`}
                >
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{item.followup_student_name}</td>
                  <td className="px-4 py-2">{item.followup_mobile_number1}</td>
                  <td className="px-4 py-2">{item.followup_district}</td>
                  <td className="px-4 py-2">{item.followup_city}</td>
                  <td className="px-4 py-2">{item.followup_clg_name}</td>
                  <td className="px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded text-sm font-semibold ${
                        item.followup_is_interested === "Most Interested"
                          ? "bg-green-100 text-green-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {item.followup_is_interested}
                    </span>
                  </td>
                  <td className="px-4 py-2 font-medium">
                    {item.employee_name}
                  </td>
                  <td className="px-4 py-2">
                    {item.followup_next_followup_date_time &&
                    item.followup_next_followup_date_time !== ""
                      ? new Date(
                          item.followup_next_followup_date_time
                        ).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                      : "N/A"}
                  </td>
                  <td className="px-4 py-2">{item.created_date || "N/A"}</td>
                  <td className="py-3 px-4 border-b border-gray-200">
                    <button
                      className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 text-sm"
                      onClick={() => handleEditClick(item)}
                    >
                      Followup
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeamLeadAllEmpData;
